import { render } from "./NewsContent.vue?vue&type=template&id=9794d49e&scoped=true"
import script from "./NewsContent.vue?vue&type=script&lang=js"
export * from "./NewsContent.vue?vue&type=script&lang=js"

import "./NewsContent.vue?vue&type=style&index=0&id=9794d49e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9794d49e"

export default script